var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgUnlocked = function SvgUnlocked(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 17,
    fill: "none",
    viewBox: "0 0 12 17",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10.5,
    height: 8.49,
    x: 0.75,
    y: 7.76,
    stroke: "#fff",
    strokeWidth: 1.5,
    rx: 1.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m7.827 1.822.395-.637zm.778 1.364.638.395.79-1.275-.638-.395zM4.977 1.344l.165.731zM7.432 2.46l1.173.726.79-1.275-1.173-.726zM2.75 8.01V5.066h-1.5V8.01zm2.392-5.935a3.07 3.07 0 0 1 2.29.385l.79-1.275a4.57 4.57 0 0 0-3.41-.573zM4.812.612A4.57 4.57 0 0 0 1.25 5.067h1.5c0-1.433.993-2.676 2.392-2.992z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "square",
    strokeWidth: 1.5,
    d: "M6 11v2"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUnlocked);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/unlocked.ae81c5a9c5003683c117ee375fa731bf.svg";